import { render, staticRenderFns } from "./BLForm.vue?vue&type=template&id=f4425784&scoped=true&lang=html&"
import script from "./BLForm.vue?vue&type=script&lang=js&"
export * from "./BLForm.vue?vue&type=script&lang=js&"
import style0 from "./BLForm.vue?vue&type=style&index=0&id=f4425784&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4425784",
  null
  
)

export default component.exports